<template>
    <div>
        {{ $t('notification.roleUpdated', { 
            actor: $_.get(activity, 'actorUser.name'), 
            roleName: $_.get(activity, 'payload.roleName')
        }) }}
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "RoleUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

